import { render } from "./VatTuBienBanTable.vue?vue&type=template&id=00947797&ts=true"
import script from "./VatTuBienBanTable.vue?vue&type=script&lang=ts"
export * from "./VatTuBienBanTable.vue?vue&type=script&lang=ts"

import "./VatTuBienBanTable.vue?vue&type=style&index=0&id=00947797&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__